import { render, staticRenderFns } from "./manualMarking.vue?vue&type=template&id=42009de7&scoped=true"
import script from "./manualMarking.vue?vue&type=script&lang=js"
export * from "./manualMarking.vue?vue&type=script&lang=js"
import style0 from "./manualMarking.vue?vue&type=style&index=0&id=42009de7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42009de7",
  null
  
)

export default component.exports